var URL_REG = /^https?:\/\//

export function isUrl(s) {
  return typeof s === 'string' && URL_REG.test(s.trim())
}

export function clampSeed(n) {
  if (n == null || n === '' || n === -1) return null
  var num = parseInt(n, 10)
  if (isNaN(num) || num > 2147483647) return null
  return num
}
